export default class AddPropertyValueTypeRequest {
    propertyDataTypeName:string
}
